import CircularLoader from 'components/CircularLoader';
import { FormattedMessage } from 'react-intl';
import { cn } from 'utils/cn';
import { useInvoiceRecalculating } from '../../hooks/useInvoiceRecalculating';

interface Props {
    invoiceId: number;
    isAlsoRecalculating?: boolean;
    hideLabel?: boolean;
    className?: string;
}

// Renders inside a `position: relative` host. z-10 keeps it below the modal layer, so a
// modal that triggered the recalculation stays interactive above the overlay.
const RecalculatingOverlay = ({ invoiceId, isAlsoRecalculating = false, hideLabel = false, className }: Props) => {
    const isRecalculating = useInvoiceRecalculating(invoiceId, isAlsoRecalculating);

    if (!isRecalculating) {
        return null;
    }

    return (
        <div
            role="status"
            className={cn(
                'bg-paper/60 absolute inset-0 z-10 flex cursor-wait flex-col items-center justify-center gap-3',
                className
            )}
        >
            <CircularLoader className="static size-auto" />
            {hideLabel ? (
                <span className="sr-only">
                    <FormattedMessage id="invoices.recalculating-totals" />
                </span>
            ) : (
                <p className="text-body1 text-fg-secondary">
                    <FormattedMessage id="invoices.recalculating-totals" />
                </p>
            )}
        </div>
    );
};

export default RecalculatingOverlay;
